<template>
	<ToolPlacementTreeBlock
		v-on="$listeners"
		v-bind="$attrs"
		:isChosen="isChosen"
		:toolTitle="toolTitle"
		:toolPlacement="toolPlacementTitle"
		:toolPlacementIcon="toolPlacementIcon"
		:toolIcon="toolIcon"
		:portalAuthText="portalAuthText"
	/>
</template>

<script>
import ToolPlacementTreeBlock from './ToolPlacementTreeBlock.vue';
import { editNode } from '@/store/modules/selectedNode/getters';
import { editWorkflow, isCustomerAuthOn, customerAuthSettings } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import WorkflowToolService from '@/utils/workflow-tool-service';

export default {
	name: 'ToolPlacementTreeBlockDataProvider',
	components: { ToolPlacementTreeBlock },
	props: { blockData: { type: Object } },
	computed: {
		...mapGettersShorthand({ editNode, editWorkflow, isCustomerAuthOn, customerAuthSettings }),
		isChosen() {
			const isChosen = this.editNode?.id === this.blockData.id;
			return isChosen;
		},
		toolIcon() {
			return this.editWorkflow.icon_name;
		},
		toolTitle() {
			return WorkflowToolService.getMatchingToolTitle(this.editWorkflow);
		},
		toolPlacementTitle() {
			return WorkflowToolService.getMatchingToolPlacementTitle(this.editWorkflow);
		},
		toolPlacementIcon() {
			return WorkflowToolService.getMatchingToolPlacementIcon(this.editWorkflow);
		},
		portalAuthText() {
			return this.isCustomerAuthOn ? this.customerAuthSettings.customer_auth_text || 'Welcome!' : null;
		},
	},
};
</script>

<style lang="scss" scoped></style>
